
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class CustomLayoutComponent extends Vue {
    //name: "layout"
    constructor() {
        super();
    }

    sidebarActive: boolean = false
    showSidebarFlag: boolean = false

    showSidebar() {
        this.sidebarActive = !this.sidebarActive
        this.showSidebarFlag = !this.showSidebarFlag
    }
}
